/**
 * Merges multiple FAQ section JSON-LD fragments into a single FAQPage script.
 * Each dynamic-faq section outputs a script[data-faq-entities] with a JSON array
 * of Question objects; this script collects them and outputs one application/ld+json.
 */
(function () {
  var scripts = document.querySelectorAll('script[data-faq-entities]');
  if (scripts.length === 0) return;

  var mainEntity = [];
  for (var i = 0; i < scripts.length; i++) {
    try {
      var entities = JSON.parse(scripts[i].textContent);
      if (Array.isArray(entities)) {
        mainEntity = mainEntity.concat(entities);
      }
    } catch (e) {
      /* ignore invalid JSON per section */
    }
  }

  if (mainEntity.length === 0) return;

  var faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: mainEntity
  };

  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(faqPage);
  document.head.appendChild(script);

  for (var j = scripts.length - 1; j >= 0; j--) {
    scripts[j].parentNode.removeChild(scripts[j]);
  }
})();
